import Avatar from "@mui/material/Avatar";
import React from "react";
import { date_to_display } from "../../../utils/constant";

export default function ConversationCard({ conversation, selected, onClick }) {
  return (
    <div
      className={`d-flex align-items-center p-3 ps-0 ps-md-3 cursor-pointer conversation-card gap-2 ${
        selected ? "selected" : ""
      }`}
      onClick={onClick}
    >
      <div className="conversation-avatar">
        <Avatar src={conversation.avatar || undefined}>
          {conversation.first_name?.[0] || "A"}
        </Avatar>
      </div>
      <div className="flex-grow-1">
        <div className="d-flex justify-content-between align-items-center">
          <span className="fw-bold">{`${conversation.first_name} ${conversation.last_name}`}</span>
          <span className="text-muted small">
            {date_to_display(conversation.message_created_at)}
          </span>
        </div>
        {conversation.last_message && (
          <div className="text-truncate text-muted small ellipsis-text">
            {conversation.last_message}
          </div>
        )}
      </div>
    </div>
  );
}
